<template>
  <div
    class="rs-searchresults__vue"
    :class="{ 'rs-searchresults__vue__is-loading': isLoading }"
  >
    <RSSearchResultsSidebar
      :fetchedResults="fetchedResults"
      :selectedFormats="selectedFormats"
      :selectedCategories="selectedCategories"
      :isExpandable="false"
      :strings="strings"
      @selected-formats-change-request="onSelectedFormatsChangeRequest"
      @selected-categories-change-request="onSelectedCategoriesChangeRequest"
    />
    <RSSearchResultsSidebar
      :fetchedResults="fetchedResults"
      :selectedFormats="selectedFormats"
      :selectedCategories="selectedCategories"
      :isExpandable="true"
      :strings="strings"
      @selected-formats-change-request="onSelectedFormatsChangeRequest"
      @selected-categories-change-request="onSelectedCategoriesChangeRequest"
    />
    <RSSearchResultsMain
      :fetchedResults="fetchedResults"
      :selectedSortBy="selectedSortBy"
      :strings="strings"
      :currentPage="currentPage"
      :totalPages="totalPages"
      @sortby-change-request="onSortByChangeRequest"
      @page-change-request="onPageChangeRequest"
    />
  </div>
</template>

<script>
import RSSearchResultsSidebar from "./RSSearchResultsSidebar.vue";
import RSSearchResultsMain from "./RSSearchResultsMain.vue";

export default {
  components: {
    RSSearchResultsSidebar,
    RSSearchResultsMain,
  },
  props: {
    isTheArchivePage: Boolean,
    searchInput: HTMLInputElement,
    lang: String,
    strings: Object,
    // basePath: String,
  },
  data() {
    return {
      // basePath: "/archive/",
      fetchedResults: {},
      // selectedLanguages: ["en"],
      selectedFormats: [],
      selectedCategories: [],
      selectedSortBy: "relevance",
      taxonomyTermsBackendIsFiguringOut: [],
      fetchResultsAbortController: undefined,
      isLoading: false,
      // maxDisplayedPage: 1,
      // maxLoadedPage: 1,
      // bottomCardObserver: undefined,
      currentPage: 1,
      totalPages: 1,
      searchKeywords: "",
      isSearchInputExpanded: false,
      isArchiveRevealed: false,
      originalPath: "",
      modalState: "MODAL_STATE_OFF", // 'MODAL_STATE_OFF' 'MODAL_STATE_GLIMPSING' 'MODAL_STATE_LOCKED'
      isSearchResultsPointerDown: false,
    };
  },
  watch: {
    $route(to, from) {
      this.updateAfterRouteChange();
    },
    // selectedLanguages(newValue, oldValue) {},
    selectedFormats(newValue, oldValue) {},
    selectedCategories(newValue, oldValue) {},
    selectedSortBy(newValue, oldValue) {},
    searchKeywords(newValue, oldValue) {
      // if (newValue) this.searchInput.focus();
    },
    isSearchInputExpanded(newValue, oldValue) {
      newValue ? window.rsExpandSearchInput() : window.rsCollapseSearchInput();
    },
    isArchiveRevealed(newValue, oldValue) {
      !this.isTheArchivePage && newValue
        ? window.rsRevealArchive()
        : window.rsConcealArchive();
    },
    modalState(newState, oldState) {
      if (!this.isTheArchivePage) {
        if (newState === "MODAL_STATE_GLIMPSING") {
          this.fetchResults();
        }
      }
    },
  },
  computed: {
    basePath() {
      let _basePath = "/";
      if (this.lang && this.lang !== "en") _basePath += this.lang + "/";
      _basePath += encodeURIComponent(this.strings["archive"]);
      _basePath += "/";
      return _basePath;
    },
  },
  mounted() {
    this.$el.addEventListener("pointerdown", this.onSearchResultsPointerDown);
    if (this.isTheArchivePage) {
      this.updateAfterRouteChange();
    } else {
      this.originalPath = this.$route.fullPath;
    }
  },
  methods: {
    updateAfterRouteChange() {
      if (
        this.isTheArchivePage ||
        (this.$route.fullPath.indexOf(this.basePath) === 0 &&
          this.$route.fullPath !== this.originalPath)
      ) {
        this.modalState = "MODAL_STATE_LOCKED";
        let updatedRoute = new URL(this.$route.fullPath, window.location);
        let folders = updatedRoute.pathname
          .replace(this.basePath, "")
          .split("/")
          .filter((item) => item.length);
        if (folders.length > 0) {
          if (folders.length === 1) {
            this.taxonomyTermsBackendIsFiguringOut = folders[0].split(",");
          } else {
            this.selectedFormats = folders[0].split(",");
            this.selectedCategories = folders[1].split(",");
          }
        } else {
          this.selectedFormats = [];
          this.selectedCategories = [];
          this.taxonomyTermsBackendIsFiguringOut = [];
        }
        updatedRoute.searchParams.get("s")
          ? (this.searchKeywords = decodeURIComponent(
              updatedRoute.searchParams.get("s")
            ))
          : (this.searchKeywords = "");
        this.searchInput.value = this.searchKeywords;
        updatedRoute.searchParams.get("sortby")
          ? (this.selectedSortBy = updatedRoute.searchParams.get("sortby"))
          : (this.selectedSortBy = "relevance");
        // updatedRoute.searchParams.get("lang")
        //   ? (this.selectedLanguages = updatedRoute.searchParams
        //       .get("lang")
        //       .split(","))
        //   : (this.selectedLanguages = ["en"]);
        if (updatedRoute.searchParams.get("page")) {
          // console.log("updatedRoute.searchParams.get('p')", updatedRoute.searchParams.get("page"));
          this.currentPage = parseInt(
            decodeURIComponent(updatedRoute.searchParams.get("page"))
          );
        } else {
          // console.log("currentPage", this.currentPage);
          this.currentPage = 1;
        }
        // console.info("updateAfterRouteChange, will fetchResults");
        this.fetchResults();
      } else {
        this.modalState = "MODAL_STATE_OFF";
        this.selectedLanguages = [];
        this.selectedFormats = [];
        this.selectedCategories = [];
        this.taxonomyTermsBackendIsFiguringOut = [];
        this.searchKeywords = "";
        this.searchInput.value = "";
        this.searchInput.blur();
        this.selectedSortBy = "relevance";
        this.currentPage = 1;
      }
      this.updateExpansionStates();
    },
    updateAfterStateChange() {
      // console.info("updateAfterStateChange");
      if (this.isTheArchivePage || this.modalState === "MODAL_STATE_LOCKED") {
        let newRouteString = this.basePath;
        let formatsPart = "";
        this.selectedFormats.forEach((element) => {
          if (formatsPart.length) formatsPart += ",";
          formatsPart += element;
        });
        if (formatsPart.length) formatsPart += "/";
        newRouteString += formatsPart;
        let categoriesPart = "";
        this.selectedCategories.forEach((element) => {
          if (categoriesPart.length) categoriesPart += ",";
          categoriesPart += element;
        });
        if (categoriesPart.length) categoriesPart += "/";
        newRouteString += categoriesPart;
        let queryString = [];
        if (this.searchKeywords.length)
          queryString.push("s=" + this.searchKeywords);
        if (this.selectedSortBy !== "relevance")
          queryString.push("sortby=" + this.selectedSortBy);
        // if (
        //   this.selectedLanguages.join(",") !== "en" &&
        //   this.selectedLanguages.join(",") !== ""
        // ) {
        //   queryString.push("lang=" + this.selectedLanguages.join(","));
        // }
        if (this.currentPage !== 1)
          queryString.push("page=" + this.currentPage);
        if (queryString.length)
          for (let i = 0; i < queryString.length; i++)
            i === 0
              ? (newRouteString += "?" + queryString[i])
              : (newRouteString += "&" + queryString[i]);
        if (
          decodeURIComponent(this.$route.fullPath) !==
          decodeURIComponent(newRouteString)
        ) {
          this.$router.push(newRouteString);
          // console.info("updateAfterStateChange, will fetchResults");
          // this.fetchResults();
        }
      } else if (this.modalState === "MODAL_STATE_OFF") {
        if (this.$route.fullPath !== this.originalPath) {
          this.$router.push(this.originalPath);
        }
      }
      this.updateExpansionStates();
    },
    updateExpansionStates() {
      if (this.isTheArchivePage) {
        if (
          this.searchInput.value.length ||
          this.searchInput === document.activeElement
        ) {
          this.isSearchInputExpanded = true;
        } else {
          this.isSearchInputExpanded = false;
        }
      } else {
        if (
          this.modalState === "MODAL_STATE_GLIMPSING" ||
          this.modalState === "MODAL_STATE_LOCKED" ||
          this.searchInput.value.length ||
          this.searchInput === document.activeElement
        ) {
          this.isSearchInputExpanded = true;
          this.isArchiveRevealed = true;
        } else {
          this.isSearchInputExpanded = false;
          this.isArchiveRevealed = false;
        }
      }
    },
    // onBottomCardChange(newBottomCard) {
    //   if (this.bottomCardObserver) this.bottomCardObserver.disconnect();
    //   this.bottomCardObserver = new IntersectionObserver(
    //     (entries, observer) => {
    //       if (entries[0].isIntersecting) {
    //         this.fetchMoreResults();
    //       }
    //     },
    //     {
    //       rootMargin: "0px 0px 0px 0px",
    //       threshold: 0,
    //     }
    //   );
    //   this.bottomCardObserver.observe(newBottomCard.$el);
    // },
    onSearchInputFocus() {
      if (!this.isTheArchivePage && this.modalState === "MODAL_STATE_OFF") {
        this.modalState = "MODAL_STATE_GLIMPSING";
      }
      this.updateAfterStateChange();
    },
    onSearchInputBlur() {
      setTimeout(() => {
        if (
          !this.isTheArchivePage &&
          this.modalState === "MODAL_STATE_GLIMPSING" &&
          !this.searchInput.value.length
        ) {
          if (this.isSearchResultsPointerDown) {
            this.modalState = "MODAL_STATE_LOCKED";
          } else {
            this.modalState = "MODAL_STATE_OFF";
          }
        }
        // this.currentPage = 1;
        // window.scrollTo(0, 0);
        this.updateAfterStateChange();
      });
    },
    onSearchResultsPointerDown(e) {
      this.isSearchResultsPointerDown = true;
    },
    onSearchResultsPointerUp(e) {
      this.isSearchResultsPointerDown = false;
    },
    onSearchInputClick() {
      // this.updateAfterStateChange();
    },
    onSearchInputInput() {
      // this.updateAfterStateChange();
      this.searchKeywords = this.searchInput.value;
      // this.fetchResults();
    },
    onSearchInputSubmit() {
      this.modalState = "MODAL_STATE_LOCKED";
      this.searchKeywords = this.searchInput.value;
      this.currentPage = 1;
      window.scrollTo(0, 0);
      this.updateAfterStateChange();
    },
    onSearchInputArrowDown() {
      // this.updateAfterStateChange();
    },
    onSearchCloseClick() {
      this.searchInput.blur();
      this.searchKeywords = "";
      this.searchInput.value = "";
      if (!this.isTheArchivePage) {
        this.selectedFormats = [];
        this.selectedCategories = [];
        this.selectedSortBy = "relevance";
        this.modalState = "MODAL_STATE_OFF";
      }
      this.updateAfterStateChange();
    },
    onSortByChangeRequest(requestedSortBy) {
      this.selectedSortBy = requestedSortBy;
      this.currentPage = 1;
      window.scrollTo(0, 0);
      this.updateAfterStateChange();
    },
    // onSelectedLanguagesChangeRequest(newSlugList) {
    //   this.selectedLanguages = newSlugList.sort();
    //   this.updateAfterStateChange();
    // },
    onSelectedFormatsChangeRequest(newSlugList) {
      this.selectedFormats = newSlugList.sort();
      this.currentPage = 1;
      window.scrollTo(0, 0);
      this.updateAfterStateChange();
    },
    onSelectedCategoriesChangeRequest(newSlugList) {
      this.selectedCategories = newSlugList.sort();
      this.currentPage = 1;
      window.scrollTo(0, 0);
      this.updateAfterStateChange();
    },
    onPageChangeRequest(newPage) {
      if (newPage != this.currentPage) {
        this.currentPage = newPage;
        window.scrollTo(0, 0);
        this.updateAfterStateChange();
      }
    },
    fetchResults() {
      let endpoint = "/wp-json/rs/v1/search/";
      let queryString = [];
      if (this.searchKeywords && this.searchKeywords.length)
        queryString.push("s=" + this.searchKeywords);
      if (this.selectedSortBy && this.selectedSortBy.length)
        queryString.push("sortby=" + this.selectedSortBy);
      if (this.selectedFormats && this.selectedFormats.length)
        queryString.push("rs_format=" + this.selectedFormats.join(","));
      if (this.selectedCategories && this.selectedCategories.length)
        queryString.push("category=" + this.selectedCategories.join(","));
      queryString.push("lang=" + (this.lang ? this.lang : "en"));
      queryString.push("page=" + this.currentPage);

      if (
        this.taxonomyTermsBackendIsFiguringOut &&
        this.taxonomyTermsBackendIsFiguringOut.length
      )
        queryString.push(
          "figure_these_out=" + this.taxonomyTermsBackendIsFiguringOut.join(",")
        );
      if (queryString.length)
        for (let i = 0; i < queryString.length; i++)
          i === 0
            ? (endpoint += "?" + queryString[i])
            : (endpoint += "&" + queryString[i]);
      if (this.fetchResultsAbortController)
        this.fetchResultsAbortController.abort();
      this.fetchResultsAbortController = new AbortController();
      let signal = this.fetchResultsAbortController.signal;
      this.isLoading = true;
      fetch(endpoint, { signal })
        .then((response) => response.json())
        .then((data) => {
          if (data && data["figured_out_taxonomy"]) {
            switch (data["figured_out_taxonomy"]) {
              case "rs_format":
                this.selectedFormats = this.taxonomyTermsBackendIsFiguringOut;
                this.selectedCategories = [];
                break;
              case "category":
                this.selectedFormats = [];
                this.selectedCategories =
                  this.taxonomyTermsBackendIsFiguringOut;
                break;
            }
            this.taxonomyTermsBackendIsFiguringOut = [];
          }
          this.fetchedResults = data;
          this.isLoading = false;
          // this.maxDisplayedPage = 1;
          // this.maxLoadedPage = 1;
          this.totalPages = data["total_pages"];
        })
        .catch((error) => {
          if (error.name !== "AbortError") {
            console.log(error);
          }
        });
    },
    // fetchMoreResults() {
    // if (
    //   this.maxDisplayedPage < this.fetchedResults["total_pages"] &&
    //   this.maxDisplayedPage === this.maxLoadedPage
    // ) {
    //   let endpoint = "/wp-json/rs/v1/search/";
    //   let queryString = ["page=" + ++this.maxLoadedPage];
    //   if (this.searchKeywords && this.searchKeywords.length)
    //     queryString.push("s=" + this.searchKeywords);
    //   if (this.selectedSortBy && this.selectedSortBy.length)
    //     queryString.push("sortby=" + this.selectedSortBy);
    //   if (this.selectedFormats && this.selectedFormats.length)
    //     queryString.push("rs_format=" + this.selectedFormats.join(","));
    //   if (this.selectedCategories && this.selectedCategories.length)
    //     queryString.push("category=" + this.selectedCategories.join(","));
    //   if (this.selectedLanguages && this.selectedLanguages.length)
    //     queryString.push("lang=" + this.selectedLanguages.join(","));
    //   if (
    //     this.taxonomyTermsBackendIsFiguringOut &&
    //     this.taxonomyTermsBackendIsFiguringOut.length
    //   )
    //     queryString.push(
    //       "figure_these_out=" +
    //         this.taxonomyTermsBackendIsFiguringOut.join(",")
    //     );
    //   if (queryString.length)
    //     for (let i = 0; i < queryString.length; i++)
    //       i === 0
    //         ? (endpoint += "?" + queryString[i])
    //         : (endpoint += "&" + queryString[i]);
    //   if (this.fetchResultsAbortController)
    //     this.fetchResultsAbortController.abort();
    //   this.fetchResultsAbortController = new AbortController();
    //   let signal = this.fetchResultsAbortController.signal;
    //   this.isLoading = true;
    //   fetch(endpoint, { signal })
    //     .then((response) => response.json())
    //     .then((data) => {
    //       this.fetchedResults["posts"].push(...data["posts"]);
    //       this.isLoading = false;
    //       this.maxDisplayedPage = data["current_page"];
    //     })
    //     .catch((error) => {
    //       if (error.name !== "AbortError") {
    //         console.log(error);
    //       }
    //     });
    // }
    // },
  },
};
</script>
